<template>
  <div class="ma-6 mt-4 pr-0 pl-0 pt-2 border_all">
    <div class="page-header-left">
      <h2 class="pr-3">Management User</h2>
      <v-spacer></v-spacer>
      <div class="listtotal mt-2">
        <v-card style="border: thin solid rgba(0,0,0,.12)" class="listtotal border_all mr-2" elevation="0">
          <v-sheet class="" color="green" width="50" height="50" elevation="0">
            <v-icon dark large class="icondash">shopping_cart</v-icon>
          </v-sheet>
          <div class="pl-2 pr-10">
            <div>Total Users</div>
            <div>{{formatAngka(sumuser.totaluser)}}</div>
          </div>
        </v-card>
        <v-card style="border: thin solid rgba(0,0,0,.12)" class="listtotal border_all mr-2" elevation="0">
          <v-sheet class="" color="green" width="50" height="50" elevation="0">
            <v-icon dark large class="icondash">shopping_cart</v-icon>
          </v-sheet>
          <div class="pl-2 pr-10">
            <div>Total Seller</div>
            <div>{{formatAngka(sumuser.totalseller)}}</div>
          </div>
        </v-card>
        <v-card style="border: thin solid rgba(0,0,0,.12)" class="listtotal border_all mr-2" elevation="0">
          <v-sheet class="" color="green" width="50" height="50" elevation="0">
            <v-icon dark large class="icondash">shopping_cart</v-icon>
          </v-sheet>
          <div class="pl-2 pr-10">
            <div>Pengajuan Penjual</div>
            <div>{{formatAngka(sumuser.totalreqseller)}}</div>
          </div>
        </v-card>
      </div>
    </div>
    <div style="border: thin solid rgba(0,0,0,.12)" class="mt-4">
      <v-tabs  v-model="tab">
        <v-tab>Semua User</v-tab>
        <v-tab><v-badge color="green" :content="totalsellerreq">Pengajuan Penjual</v-badge></v-tab>
        <v-tab-item>
          <AllUser/>
        </v-tab-item>
        <v-tab-item>
          <ViewSellerReq/>
        </v-tab-item>
      </v-tabs>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Utils from '@/plugins/utils'
import moment from 'moment'
import ViewSellerReq from '@/components/ViewSellerReq'
import AllUser from '@/components/admin/AllUser'

export default {
  name: 'UserManagement',
  components: { AllUser, ViewSellerReq },
  data: () => ({
    tab: null,
    opsitable: {
      search: '',
      itemsPerPage: 10,
      page: 1,
      paymentstatus: '',
      sortBy: ['memberid']
    },
    headers: [
      {
        text: 'Id',
        value: 'memberid'
      },
      {
        text: 'Nama',
        value: 'membername'
      },
      {
        text: 'Email',
        value: 'memberemail'
      },
      {
        text: 'Akif',
        value: 'memberstatus'
      },
      {
        text: 'CreateAt',
        value: 'createat'
      },
      {
        text: 'UpdateAt',
        value: 'updateat'
      },
      {
        text: 'Aksi',
        value: 'aksi'
      }

    ]
  }),
  mounted () {
    this.getSumUser()
    this.getSellerReq(this.opsitable)
  },
  computed: {
    ...mapState('AdminUserStore', ['adminuser', 'loading', 'userdetail', 'totaladminuser', 'totalsellerreq', 'sellerreq', 'sumuser'])
  },
  methods: {
    ...mapActions('AdminUserStore', ['getUserDetail', 'getAllUsers', 'getSellerReq', 'setdialoguserdetail', 'getRoles', 'getSumUser']),
    colorStatus (val) {
      if (parseInt(val) > 1) {
        return 'green'
      } else {
        return 'red'
      }
    },
    statusText (val) {
      if (parseInt(val) > 1) {
        return 'Aktif'
      } else {
        return 'Non Aktif'
      }
    },
    statusconfm (val) {
      if (parseInt(val) === 1) {
        return 'Ya'
      } else {
        return 'Belum'
      }
    },
    formatAngka (val) {
      return Utils.formatAngka(val)
    },
    formatDate (value) {
      return moment(value).add(0, 'hours').format('YYYY/MM/DD HH:mm:ss')
    },
    blocuser (item) {

    },
    opendetail (item) {
      console.log(item)
      this.getUserDetail(item.memberid)
      this.getRoles()
      this.setdialoguserdetail(true)
    },
    refreshdata () {
      this.getAllUsers(this.opsitable)
      this.getSumUser()
    }
  }
}
</script>

<style scoped>
.listtotal {
  display:flex;
  flex-wrap: wrap;
}
.icondash {
  margin-left: 6px;
  margin-top: 10px;
}
</style>
